import { useNavigate } from 'react-router-dom'

import { Button, Card, Section } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface PayrollConceptsProps {
  legacyPayroll?: boolean
}

const PayrollConcepts = ({ legacyPayroll = false }: PayrollConceptsProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const description = legacyPayroll
    ? i18n.t('app_store_v2.apps.payroll_bundle.settings.concepts.description')
    : i18n.t('compensations.settings.concepts.section.description')

  const onClick = () => {
    if (legacyPayroll) {
      navigate(navigation.settings.payroll_bundle.concepts.fullPath())
    } else {
      navigate(navigation.settings.compensations.payrollConcepts.fullPath())
    }
  }

  return (
    <>
      <Section
        illustration="money-bag"
        title={i18n.t('compensations.settings.concepts.section.title')}
        description={description}
      >
        <Card height="s64">
          <Card.Title
            size="small"
            action={<Button onClick={onClick} type="secondary" iconName="arrow-right" />}
          >
            {i18n.t('compensations.settings.concepts.section.cta')}
          </Card.Title>
        </Card>
      </Section>
    </>
  )
}

export default PayrollConcepts
